module.exports = __webpack_public_path__ + "img/large_arrow_right.b7f0c716.svg";